export default "__VITE_ASSET__BaO9z4ue__"